/**
 * @copyright (C) 2023, rsupport. All rights reserved
 *
 * @license
 * This software and/or source code may be used, copied and/or disseminated only
 * with the written permission of rsupport, or in accordance with the terms
 * and conditions stipulated in the agreement/contract under which the software
 * and/or source code has been supplied by rsupport or its affiliates.
 * Unauthorized use, copying, or dissemination of this file, via any medium, is
 * strictly prohibited, and will constitute an infringement of copyright.
 *
 * @author
 * SoonKi Min (skmin@rsupport.com)
 *
 * @description
 *
 * @created at Wed Oct 11 2023
 **/

import { css } from "@emotion/react";
import styled from "@emotion/styled";

import { Column, Row, Typography, TypographyCSS } from "@/frameworks/designStuff/components";

export const ReplyMark = styled(Column)`
	position: absolute;
	left: 0;
	bottom: 100%;
	background: #e0ecf7;
	padding: 8px 16px;
	border-radius: 12px;
	width: 100%;
	max-height: 120px;
	border: 1px solid ${({ theme }) => theme.colors.neutral_00_80};
`;

export const ReplyTargetText = styled(Typography)`
	text-overflow: ellipsis;
	overflow: hidden;
	word-break: break-word;
	display: -webkit-box;
	-webkit-line-clamp: 2;
	-webkit-box-orient: vertical;
`;

export const Sender = css`
	max-width: 130px;
	overflow: hidden;
	text-overflow: ellipsis;
	word-break: break-all;
	white-space: nowrap;
`;

export const Message = styled(Row)`
	text-overflow: ellipsis;
	overflow: hidden;
	word-break: break-word;
	display: -webkit-box;
	-webkit-line-clamp: 1;
	-webkit-box-orient: vertical;
	padding: 4px;
	border-radius: 4px;

	// codeBlock은  다른 랜더 컴포넌트와 다르게 padding 처리가 있어서 상위에서 말줄임시 깨져보이기 때문에 해당 코드 추가
	.codeBlock {
		text-overflow: ellipsis;
		overflow: hidden;
		word-break: break-word;
		display: -webkit-box;
		-webkit-line-clamp: 3;
		-webkit-box-orient: vertical;
	}

	> div {
		> div {
			${TypographyCSS("Body3")};
			color: ${({ theme }) => theme.colors.neutral_50_100};
		}
	}
	&:hover {
		background-color: ${({ theme }) => theme.colors.secondary_80_16};
	}
`;

export const ReplyTo = styled(Row)`
	#target-view {
		${TypographyCSS("Title3", "accent_40_100")}
	}
	#description-view {
		${TypographyCSS("Title3")}
	}
	#target-marker {
		${TypographyCSS("Title2", "accent_40_100")};
		${Sender}
	}
	#description-marker {
		${TypographyCSS("Title2")}
	}
`;
